import * as React from "react";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Unstable_Grid2";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Divider from "@mui/material/Divider";
import ConfigData from "../config/config.json";

const webserver = ConfigData.WEBSERVER;

export default function RecipeSelector(props) {
  const [value, setValue] = React.useState(null);

  React.useEffect(() => {
    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/stats/getStatistics",
      { method: "GET", credentials: "include" }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Error: " + response.status);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        setValue(data);
      })
      .catch((error) => {});
  }, []);

  return (
    <Box sx={{ width: "100%" }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Typography
            sx={{
              minWidth: 230,
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "140%",
              mb: "0.7%",
            }}
          >
            Aktuelle Statistiken
          </Typography>
        </Grid>

        <Grid item xs={2} md={4}>
          <Card sx={{ minWidth: 230, textAlign: "center" }}>
            <CardContent>
              <Typography sx={{ fontSize: 16 }} color="text.first" gutterBottom>
                Offene Apotheken
              </Typography>

              <Typography
                sx={{ color: "#009fe3", fontSize: 20, fontWeight: "bold" }}
                color="text.secondary"
              >
                {value !== null ? value.openPharms : "null"}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={2} sm={4} md={4}>
          <Card sx={{ minWidth: 230, textAlign: "center" }}>
            <CardContent>
              <Typography sx={{ fontSize: 16 }} color="text.first" gutterBottom>
                Offene geprüfte Apotheken
              </Typography>
              <Typography
                sx={{ color: "#009fe3", fontSize: 20, fontWeight: "bold" }}
                color="text.secondary"
              >
                {value !== null ? value.openExaminedPharms : "null"}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={2} sm={4} md={4}>
          <Card sx={{ minWidth: 230, textAlign: "center" }}>
            <CardContent>
              <Typography sx={{ fontSize: 16 }} color="text.first" gutterBottom>
                Durchgefallene Apotheken
              </Typography>

              <Typography
                sx={{ color: "#009fe3", fontSize: 20, fontWeight: "bold" }}
                color="text.secondary"
              >
                {value !== null ? value.openFailedPharmsfailureRate : "null"}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={2} sm={3} md={3} sx={{ textAlign: "center", mt: 5 }}>
          <ArrowForwardIosIcon fontSize="large" color="warning" />
        </Grid>

        <Grid item xs={2} sm={3} md={3}>
          <Card sx={{ minWidth: 250, mt: 2, textAlign: "center" }}>
            <CardContent>
              <Typography sx={{ fontSize: 16 }} color="text.first" gutterBottom>
                Abdeckungsrate
              </Typography>

              <Typography
                sx={{
                  color: "green",
                  fontSize: 20,
                  fontWeight: "bold",
                  textAlign: "center",
                }}
                color="text.secondary"
              >
                {value === null ||
                value.openPharms === null ||
                value.openPharms === 0
                  ? "0.00"
                  : (
                      ((value !== null ? value.openExaminedPharms : 0) /
                        value.openPharms) *
                      100
                    ).toFixed(2)}
                %
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={2} sm={3} md={3}>
          <Card sx={{ minWidth: 250, mt: 2, textAlign: "center" }}>
            <CardContent>
              <Typography sx={{ fontSize: 16 }} color="text.first" gutterBottom>
                Durchfallquote
              </Typography>

              <Typography
                sx={{
                  color: "red",
                  fontSize: 20,
                  fontWeight: "bold",
                  textAlign: "center",
                }}
                color="text.secondary"
              >
                {value === null || value.openExaminedPharms === 0
                  ? "0.00"
                  : (
                      ((value !== null
                        ? value.openFailedPharmsfailureRate
                        : 0) /
                        value.openExaminedPharms) *
                      100
                    ).toFixed(2)}
                %
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={2} sm={3} md={3} sx={{ textAlign: "center", mt: 5 }}>
          <ArrowBackIosIcon fontSize="large" color="warning" />
        </Grid>
      </Grid>

      <Divider sx={{ mt: "4%", mb: "1%" }} />
    </Box>
  );
}
